"use client";

import * as React from "react";
import { ReactSVG } from "react-svg";
import { Typography } from "@/components/Typography";
import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { QRProps } from "@/contexts/QREditorContext/types";

import { useEmptyData } from "./hooks/useEmptyData";

import "./EmptyPreview.scss";

export const EmptyPreview = (props: QRProps<any>) => {
  const { isInitialPreview, defaultPreviewTitle } = useEmptyData(props);

  return (
    <PhoneLayout
      page={"empty" as any}
      dataQA="preview-empty-container"
      backgroundColor={"white"}
      isInitPreview={isInitialPreview}
    >
      <div className="empty-template__container">
        <ReactSVG src={`/svg/icon-choose.svg`} />
        <Typography
          Tag="p"
          classname="u-spacing-5"
        >
          {defaultPreviewTitle}
        </Typography>
      </div>
    </PhoneLayout>
  );
};
